/**
 * 解析后端时间字符串。
 * `get_user_info` 等接口的 naive 时间（`YYYY-MM-DD HH:mm:ss`）按 UTC 存储，无时区后缀。
 * 不能直接 `new Date(str)`：空格格式在 Safari 会失败，且会被当成本地时间导致日期偏移。
 */
export function parseBackendDateTime(raw: string | null | undefined): Date | null {
  if (raw == null) return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;

  if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(trimmed)) {
    const d = new Date(trimmed);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const iso = trimmed.includes('T') ? trimmed : trimmed.replace(' ', 'T');
  const naive = /^\d{4}-\d{2}-\d{2}(?:[T ]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)?$/.test(iso);
  const d = new Date(naive ? `${iso}Z` : iso);
  return Number.isNaN(d.getTime()) ? null : d;
}
